import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddCustomerItemsMutationVariables = Types.Exact<{
  input: Types.AddCustomerItemsInput;
}>;


export type AddCustomerItemsMutation = { __typename?: 'Mutation', addCustomerItems: { __typename?: 'CustomerItemBulkActionPayload', customerItems?: Array<{ __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, typedErrors?: { __typename?: 'CustomerItemTypedErrors', effectiveDateOverlap?: { __typename?: 'CustomerItemEffectiveDateOverlap', customerItemId: string, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null } | null, upcSkuCollision?: { __typename?: 'CustomerItemUpcSkuCollision', customerItemId: string, sku: string, upc: string } | null } | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddCustomerItemMutationVariables = Types.Exact<{
  input: Types.AddCustomerItemInput;
}>;


export type AddCustomerItemMutation = { __typename?: 'Mutation', addCustomerItem: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, typedErrors?: { __typename?: 'CustomerItemTypedErrors', effectiveDateOverlap?: { __typename?: 'CustomerItemEffectiveDateOverlap', customerItemId: string, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null } | null, upcSkuCollision?: { __typename?: 'CustomerItemUpcSkuCollision', customerItemId: string, sku: string, upc: string } | null } | null } };

export type UpdateCustomerItemMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerItemInput;
}>;


export type UpdateCustomerItemMutation = { __typename?: 'Mutation', updateCustomerItem: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, typedErrors?: { __typename?: 'CustomerItemTypedErrors', effectiveDateOverlap?: { __typename?: 'CustomerItemEffectiveDateOverlap', customerItemId: string, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null } | null, upcSkuCollision?: { __typename?: 'CustomerItemUpcSkuCollision', customerItemId: string, sku: string, upc: string } | null } | null } };

export type SetCustomerItemEffectiveDatesMutationVariables = Types.Exact<{
  input: Types.SetCustomerItemEffectiveDatesInput;
}>;


export type SetCustomerItemEffectiveDatesMutation = { __typename?: 'Mutation', setCustomerItemEffectiveDates: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, typedErrors?: { __typename?: 'CustomerItemTypedErrors', effectiveDateOverlap?: { __typename?: 'CustomerItemEffectiveDateOverlap', customerItemId: string, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null } | null, upcSkuCollision?: { __typename?: 'CustomerItemUpcSkuCollision', customerItemId: string, sku: string, upc: string } | null } | null } };

export type ClearCustomerItemShippingConfigCategoryCodeMutationVariables = Types.Exact<{
  input: Types.ClearCustomerItemShippingConfigCategoryCodeInput;
}>;


export type ClearCustomerItemShippingConfigCategoryCodeMutation = { __typename?: 'Mutation', clearCustomerItemShippingConfigCategoryCode: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerItemShippingUomMutationVariables = Types.Exact<{
  input: Types.SetCustomerItemShippingUomInput;
}>;


export type SetCustomerItemShippingUomMutation = { __typename?: 'Mutation', setCustomerItemShippingUom: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateCustomerItemMutationVariables = Types.Exact<{
  input: Types.ActivateCustomerItemInput;
}>;


export type ActivateCustomerItemMutation = { __typename?: 'Mutation', activateCustomerItem: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateCustomerItemMutationVariables = Types.Exact<{
  input: Types.DeactivateCustomerItemInput;
}>;


export type DeactivateCustomerItemMutation = { __typename?: 'Mutation', deactivateCustomerItem: { __typename?: 'CustomerItemPayload', customerItem?: { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddCustomerItemsDocument = new TypedDocumentString(`
    mutation AddCustomerItems($input: AddCustomerItemsInput!) {
  addCustomerItems(input: $input) {
    customerItems {
      customerItem {
        ...CustomerItemState
      }
      errors {
        code
        message
      }
      typedErrors {
        ...CustomerItemTypedErrors
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment CustomerItemTypedErrors on CustomerItemTypedErrors {
  effectiveDateOverlap {
    customerItemId
    effectiveFrom
    effectiveUntil
  }
  upcSkuCollision {
    customerItemId
    sku
    upc
  }
}`);
export const AddCustomerItemDocument = new TypedDocumentString(`
    mutation AddCustomerItem($input: AddCustomerItemInput!) {
  addCustomerItem(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
    typedErrors {
      ...CustomerItemTypedErrors
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment CustomerItemTypedErrors on CustomerItemTypedErrors {
  effectiveDateOverlap {
    customerItemId
    effectiveFrom
    effectiveUntil
  }
  upcSkuCollision {
    customerItemId
    sku
    upc
  }
}`);
export const UpdateCustomerItemDocument = new TypedDocumentString(`
    mutation UpdateCustomerItem($input: UpdateCustomerItemInput!) {
  updateCustomerItem(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
    typedErrors {
      ...CustomerItemTypedErrors
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment CustomerItemTypedErrors on CustomerItemTypedErrors {
  effectiveDateOverlap {
    customerItemId
    effectiveFrom
    effectiveUntil
  }
  upcSkuCollision {
    customerItemId
    sku
    upc
  }
}`);
export const SetCustomerItemEffectiveDatesDocument = new TypedDocumentString(`
    mutation SetCustomerItemEffectiveDates($input: SetCustomerItemEffectiveDatesInput!) {
  setCustomerItemEffectiveDates(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
    typedErrors {
      ...CustomerItemTypedErrors
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment CustomerItemTypedErrors on CustomerItemTypedErrors {
  effectiveDateOverlap {
    customerItemId
    effectiveFrom
    effectiveUntil
  }
  upcSkuCollision {
    customerItemId
    sku
    upc
  }
}`);
export const ClearCustomerItemShippingConfigCategoryCodeDocument = new TypedDocumentString(`
    mutation ClearCustomerItemShippingConfigCategoryCode($input: ClearCustomerItemShippingConfigCategoryCodeInput!) {
  clearCustomerItemShippingConfigCategoryCode(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const SetCustomerItemShippingUomDocument = new TypedDocumentString(`
    mutation SetCustomerItemShippingUom($input: SetCustomerItemShippingUomInput!) {
  setCustomerItemShippingUom(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ActivateCustomerItemDocument = new TypedDocumentString(`
    mutation ActivateCustomerItem($input: ActivateCustomerItemInput!) {
  activateCustomerItem(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeactivateCustomerItemDocument = new TypedDocumentString(`
    mutation DeactivateCustomerItem($input: DeactivateCustomerItemInput!) {
  deactivateCustomerItem(input: $input) {
    customerItem {
      ...CustomerItemState
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddCustomerItems: build.mutation<AddCustomerItemsMutation, AddCustomerItemsMutationVariables>({
      query: (variables) => ({ document: AddCustomerItemsDocument, variables })
    }),
    AddCustomerItem: build.mutation<AddCustomerItemMutation, AddCustomerItemMutationVariables>({
      query: (variables) => ({ document: AddCustomerItemDocument, variables })
    }),
    UpdateCustomerItem: build.mutation<UpdateCustomerItemMutation, UpdateCustomerItemMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerItemDocument, variables })
    }),
    SetCustomerItemEffectiveDates: build.mutation<SetCustomerItemEffectiveDatesMutation, SetCustomerItemEffectiveDatesMutationVariables>({
      query: (variables) => ({ document: SetCustomerItemEffectiveDatesDocument, variables })
    }),
    ClearCustomerItemShippingConfigCategoryCode: build.mutation<ClearCustomerItemShippingConfigCategoryCodeMutation, ClearCustomerItemShippingConfigCategoryCodeMutationVariables>({
      query: (variables) => ({ document: ClearCustomerItemShippingConfigCategoryCodeDocument, variables })
    }),
    SetCustomerItemShippingUom: build.mutation<SetCustomerItemShippingUomMutation, SetCustomerItemShippingUomMutationVariables>({
      query: (variables) => ({ document: SetCustomerItemShippingUomDocument, variables })
    }),
    ActivateCustomerItem: build.mutation<ActivateCustomerItemMutation, ActivateCustomerItemMutationVariables>({
      query: (variables) => ({ document: ActivateCustomerItemDocument, variables })
    }),
    DeactivateCustomerItem: build.mutation<DeactivateCustomerItemMutation, DeactivateCustomerItemMutationVariables>({
      query: (variables) => ({ document: DeactivateCustomerItemDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddCustomerItemsMutation, useAddCustomerItemMutation, useUpdateCustomerItemMutation, useSetCustomerItemEffectiveDatesMutation, useClearCustomerItemShippingConfigCategoryCodeMutation, useSetCustomerItemShippingUomMutation, useActivateCustomerItemMutation, useDeactivateCustomerItemMutation } = injectedRtkApi;
